import { ActionButton, ActionButtonWhite } from 'components/button/button.styled'
import { GlobalSettingsDialog } from 'components/globalSettingsDialog'
import { LoadingContainer } from 'components/loadingContainer'
import { SearchBar } from 'components/searchBar'
import { useCurrentAccount } from 'hooks/admin/useAuth'
import { useGlobalSettingsDialog } from 'hooks/admin/useGlobalSettings'
import { Dialog } from 'primereact/dialog'
import React, { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { UserRole } from 'types/Organization'
import { TitleRowData } from 'types/TableHeader'

import { ActionWrapper, TableTitle, TitleRowContainer } from './titleRow.style'

interface LinkProps {
    configData: TitleRowData
    onSearch: (searchTerm: string) => void
    linkTo: string
    linkLabel: string
}

interface ModalProps {
    configData: TitleRowData
    onSearch: (searchTerm: string) => void
    children: ReactNode
    isDialogVisible: boolean
    openDialog: () => void
    closeDialog: () => void
}

type Props = LinkProps | ModalProps

export const TitleRow: React.FC<Props> = (props) => {
    const { currentAccount, isLoadingCurrentAccount, errorCurrentAccount } = useCurrentAccount()
    const settingsDialog = useGlobalSettingsDialog()

    const havePermission =
        currentAccount?.role === UserRole.orgAdmin ||
        (currentAccount?.role === UserRole.superAdmin && props.configData.buttonLabel === 'Szervezet felvétele')

    const isSuperAdmin = currentAccount?.role === UserRole.superAdmin

    if ('linkTo' in props) {
        return (
            <LoadingContainer isLoading={isLoadingCurrentAccount} error={errorCurrentAccount}>
                <TitleRowContainer>
                    <TableTitle>{props.configData.title}</TableTitle>
                    <ActionWrapper>
                        {havePermission && (
                            <Link to={props.linkTo}>
                                <ActionButton icon="pi pi-plus">{props.linkLabel}</ActionButton>
                            </Link>
                        )}
                        <SearchBar onSearch={props.onSearch} />
                    </ActionWrapper>
                </TitleRowContainer>
            </LoadingContainer>
        )
    }

    return (
        <>
            <TitleRowContainer>
                <TableTitle>{props.configData.title}</TableTitle>
                <ActionWrapper>
                    {isSuperAdmin && (
                        <ActionButtonWhite icon="pi pi-cog" onClick={settingsDialog.openDialog}>
                            Beállítások
                        </ActionButtonWhite>
                    )}
                    {havePermission && (
                        <ActionButton icon="pi pi-plus" onClick={props.openDialog}>
                            {props.configData.buttonLabel}
                        </ActionButton>
                    )}
                    <SearchBar onSearch={props.onSearch} />
                </ActionWrapper>

                {props.isDialogVisible && (
                    <Dialog
                        header={props.configData.formConfig?.dialogProps?.header || 'Form'}
                        visible={props.isDialogVisible}
                        onHide={props.closeDialog}
                        style={{ minWidth: '50vw', maxWidth: '60vw' }}
                        {...props.configData.formConfig?.dialogProps}
                        modal
                        closeOnEscape
                    >
                        {React.cloneElement(props.children as React.ReactElement, {
                            onClose: props.closeDialog,
                        })}
                    </Dialog>
                )}
            </TitleRowContainer>

            {settingsDialog.isDialogVisible && (
                <Dialog
                    header="Beállítások"
                    visible={settingsDialog.isDialogVisible}
                    onHide={settingsDialog.closeDialog}
                    style={{ minWidth: '30vw' }}
                    modal
                >
                    <GlobalSettingsDialog
                        inputValue={settingsDialog.inputValue}
                        setInputValue={settingsDialog.setInputValue}
                        saveSettings={settingsDialog.saveSettings}
                        isSaving={settingsDialog.isSaving}
                        error={settingsDialog.error}
                        onClose={settingsDialog.closeDialog}
                    />
                </Dialog>
            )}
        </>
    )
}
